import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';
import PropTypes from 'prop-types';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PreviewIcon from '@material-ui/icons/RemoveRedEyeOutlined';

import UnitEconomics from './UnitEconomics';
import SetStop from './SetStop';
import {default as SetSparkStop} from '../virtuals/SetStop';
import { getDecimalNumber } from '../../common/global';
import ACButton from '../../atoms/ACButton';
import RouteStop from './RouteStop';
import {default as SparkStop} from '../virtuals/Stop';
import { getDefaultStop, getDefaultSparkStop, getStopType } from '../../common/routes';
import { moveAndPushDown } from '../../common/collection';


import styles from './RouteStops.module.scss';

export default class RouteStops extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: -1,
    };
    this.onAddProviderStop = this.onAddProviderStop.bind(this);
    this.onAddSparkStop = this.onAddSparkStop.bind(this);

    this.onOpenProviderModal = this.onOpenProviderModal.bind(this);
    this.onOpenSparkModal = this.onOpenSparkModal.bind(this);
    this.onCloseProviderModal = this.onCloseProviderModal.bind(this);
    this.onCloseSparkModal = this.onCloseSparkModal.bind(this);
    this.onClickStop = this.onClickStop.bind(this);

    this.onSwapComplete = this.onSwapComplete.bind(this);

    this.highlightDestination = this.highlightDestination.bind(this);
  }

  static propTypes = {
    providers: PropTypes.array,
  };

  static defaultProps = {
    providers: [],
  };

  onOpenProviderModal() {
    this.setState({
      isModifyingProviderStop: true,
    });
  }

  onOpenSparkModal() {
    this.setState({
      isModifyingSparkStop: true,
      isModalOpen : true
    });
  }

  onAddProviderStop() {
    this.props.onSelectStopFunc(getDefaultStop());
    this.onOpenProviderModal();
  }

  onAddSparkStop() {
    this.props.onSelectStopFunc(getDefaultSparkStop());
    const { getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    getChallengesBySparkIdFunc('-1');
    getCluesBySparkIdFunc('-1');
    this.onOpenSparkModal();
  }


  onClickStop(stop, index) {
    if (stop) {
      stop.index = index;
    }
    this.props.onSelectStopFunc(stop);
    if (stop.type === getStopType().SPARK_STOP) {
      this.onOpenSparkModal();
    } else {
      this.onOpenProviderModal();
    }
  }

  onSwapComplete(from, to) {
    const fromInt = parseInt(from.toString());
    const toInt = parseInt(to.toString());
    const stops = moveAndPushDown(this.props.stops, fromInt, toInt);
    this.setState({
      highlight: -1,
    });
    this.props.onSwapStopsFunc(stops);
  }

  onCloseProviderModal() {
    this.setState({
      isModifyingProviderStop: false,
    });
  }
  onCloseSparkModal() {
    this.setState({
      isModifyingSparkStop: false,
    });
  }

  highlightDestination(stopNumber) {
    this.setState({
      highlight: stopNumber,
    });
  }

  renderStopInfo(stops) {
    if (isEmpty(stops)) return <div />;
    const { highlight = -1 } = cloneDeep(this.state);

    let stopNumber = 0;

    return stops.map(s => {
      ++stopNumber;
      let index = stopNumber - 1;
      s.index = index;
      if (s.type === getStopType().SPARK_STOP) {
        return (
          <SparkStop
          key={`stop-${index}`}
          onSwapFunc={this.onSwapComplete}
          highlightDestinationFunc={this.highlightDestination}
          highlight={highlight}
          stop={cloneDeep(s)}
          onClickStopFunc={() => this.onClickStop(s, index)}
        />

        )
      } else {
        return (
          <RouteStop
            storyboard={s.storyboard}
            provider={s.provider}
            item={s.item}
            clue={s.clue}
            currencySymbol={this.props.currencySymbol}
            notes={s.action || ''}
            stopType={s.type || ''}
            stopNumber={stopNumber}
            key={stopNumber}
            onClickStopFunc={() => this.onClickStop(s, index)}
            onSwapCompleteFunc={(from, to) => this.onSwapComplete(from, to)}
            highlightDestinationFunc={this.highlightDestination}
            highlight={this.state.highlight}
          />
        );
      }
    });
  }

  renderUnitEconomics(stops) {
    let payout = 0;
    let customerPrice = this.props.routePrice || 0;
    let margin = 0;
    let marginPerc = 0;

    stops.forEach(s => {
      if (s.item) {
        let item = s.item;
        const num = getDecimalNumber(item.price, 2);
        if (!isNaN(num)) {
          payout += item.price;
        }
      }
    });

    margin = customerPrice - payout;
    marginPerc = (customerPrice * margin) / 100;
    return (
      <UnitEconomics
        customerPrice={getDecimalNumber(customerPrice, 2)}
        payout={getDecimalNumber(payout, 2)}
        margin={getDecimalNumber(margin, 2)}
        marginPercentage={getDecimalNumber(marginPerc, 2)}
        currencySymbol={this.props.currencySymbol}
      />
    );
  }

  renderPreviewGoogleMapRoute() {
    const { stops = [] } = this.props;
    let { googleMapURL = '' } = this.props;

    let mapURL = `${googleMapURL}/maps/dir/`;
    stops.forEach(stop => {
      if (stop && stop.provider && stop.provider.where && stop.provider.where.address && stop.type !== "payment-only") {
        mapURL = mapURL.concat(encodeURIComponent(stop.provider.where.address), '/');
      }
    });

    return (
      <a
        href={mapURL}
        target="_blank"
        className={styles.previewRouteInGoogleMap}
        rel="noopener noreferrer"
      >
        <PreviewIcon style={{ margin: 'auto' }} />
        <span style={{ margin: 'auto 5px' }}>Preview Route in Google Map</span>
      </a>
    );
  }

  onInputChangeSpark = (query) => {
    const { getSparksFunc } = this.props;
    const filterStr = `&query=${query}`;

    getSparksFunc(filterStr);
  };

  onSelectSparkItem = (name, selectedOption) => {
    const { object = {} } = selectedOption;
    if (name === 'spark') this.props.onSelectSparkFunc(object);
    if (name === 'challenge') this.props.onSelectSparkChallengeFunc(object);
  };

  onSaveActiveStop = () => {
    this.props.onSaveStopFunc();
  };
  
  onSaveSparkStop = () => {
    if (this.props.onSaveStopFunc()) {
      this.onCloseSparkModal();
    }
  }

  onDeleteSparkStop = (index) => {
    this.props.onDeleteStopFunc(index)
    this.onCloseSparkModal();
  }

  onChangeSparkStopFunc = (name, value) => {
    if (name === 'action') {
      this.props.onUpdateStopActionFunc(value)
    }
  }


  render() {
    let stops;
    stops = this.props.stops;

    const { onClickPreview } = this.props;
    return (
      <div className={styles.root}>
        <div className={styles.title}>
          <div
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            Available Stops
          </div>
          <div className={styles.previewIcon}>
            <PreviewIcon onClick={onClickPreview} />
          </div>
          {this.renderPreviewGoogleMapRoute()}
          <ACButton
            text={'Add Provider'}
            icon={<AddCircleOutlineIcon />}
            iconLast={true}
            onClickFunc={this.onAddProviderStop}
          />
          <ACButton
            text={'Add Spark'}
            icon={<AddCircleOutlineIcon />}
            iconLast={true}
            onClickFunc={this.onAddSparkStop}
          />


        </div>
        {this.renderStopInfo(stops)}
        {this.renderUnitEconomics(stops)}
        <SetStop
          isModifying={this.state.isModifyingProviderStop}
          onCloseFunc={this.onCloseProviderModal}
          items={this.props.items}
          clues={this.props.clues}
          storyboards={this.props.storyBoards}
          clue={this.props.clue}
          stop={this.props.stop}
          key={'set-stop-key-' + this.props.stop.index || 'set-stop-key'}
          onSelectProviderFunc={this.props.onSelectProviderFunc}
          onSelectItemFunc={this.props.onSelectItemFunc}
          onSelectClueFunc={this.props.onSelectClueFunc}
          onSelectStopTypeFunc={this.props.onSelectStopTypeFunc}
          onSelectStopFunc={this.props.onSelectStopFunc}
          onUpdateStopActionFunc={this.props.onUpdateStopActionFunc}
          onUpdateStopVariablesFunc={this.props.onUpdateStopVariablesFunc}
          onUpdateStopTypeFunc={this.props.onUpdateStopTypeFunc}
          onUpdateStoryBoardFunc={this.props.onUpdateStoryBoardFunc}
          onSaveStopFunc={this.props.onSaveStopFunc}
          onDeleteStopFunc={this.props.onDeleteStopFunc}
        />
        <SetSparkStop
          stop={this.props.stop}
          sparks={cloneDeep(this.props.sparks || [])}
          challenges={this.props.challenges || []}
          clues={this.props.clues || []}
          isModalOpen={this.state.isModifyingSparkStop}
          onCloseFunc={this.onCloseSparkModal}
          onSelectFunc={this.onSelectSparkItem}
          onSelectClueFunc={this.props.onSelectSparkClueFunc}
          onChangeStopFunc={this.onChangeSparkStopFunc}
          onSaveStopFunc={this.onSaveSparkStop}
          onDeleteStopFunc={this.onDeleteSparkStop}
          onInputChangeSparkFunc={this.onInputChangeSpark}
        />


      </div>
    );
  }
}
